import { render, staticRenderFns } from "./RecetaEditorTabs.vue?vue&type=template&id=61cbe150"
import script from "./RecetaEditorTabs.vue?vue&type=script&lang=js"
export * from "./RecetaEditorTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports